import { BadgeProps, IndicatorProps } from '@setel/portal-ui';
import { ITransactionStatus } from 'shared/enums/transaction.enum';

export const GetBadgeColorForStatus: Record<
  string,
  Exclude<BadgeProps['color'], 'turquoise' | 'purple' | 'info' | 'offwhite'>
> = {
  [ITransactionStatus.SUCCESS]: 'success',
  [ITransactionStatus.ERROR]: 'error',
  [ITransactionStatus.FAILED]: 'error',
  [ITransactionStatus.PENDING]: 'lemon',
  [ITransactionStatus.CANCELLED]: 'error',
  [ITransactionStatus.INCOMING]: 'lemon',
  [ITransactionStatus.REVERSED]: 'blue',
  [ITransactionStatus.EXPIRED]: 'grey',
};

export const GetIndicatorStatusColor: Record<
  string,
  Exclude<
    IndicatorProps['color'],
    'turquoise' | 'brand' | 'purple' | 'info' | 'warning'
  >
> = {
  [ITransactionStatus.SUCCESS]: 'success',
  [ITransactionStatus.ERROR]: 'error',
  [ITransactionStatus.FAILED]: 'error',
  [ITransactionStatus.PENDING]: 'lemon',
  [ITransactionStatus.CANCELLED]: 'error',
  [ITransactionStatus.INCOMING]: 'lemon',
  [ITransactionStatus.REVERSED]: 'blue',
  [ITransactionStatus.EXPIRED]: 'grey',
};

export const TopupBadgeStatus: Record<string, BadgeProps['children']> = {
  [ITransactionStatus.SUCCESS]: 'SUCCESSFUL',
  [ITransactionStatus.ERROR]: 'ERROR',
  [ITransactionStatus.FAILED]: 'FAILED',
  [ITransactionStatus.PENDING]: 'PENDING',
  [ITransactionStatus.CANCELLED]: 'CANCELLED',
  [ITransactionStatus.INCOMING]: 'INCOMING',
  [ITransactionStatus.REVERSED]: 'REVERSED',
  [ITransactionStatus.EXPIRED]: 'EXPIRED',
};
